<script>
import ContentModal from "Modals/ContentModal.vue"
const { computed, onMounted, ref } = VueCompositionAPI
import { generateShortUUID } from "utils/uuid"
import api from "services/useApi"

export default {
    name: "NewsletterSubscriptionModal",
    components: {
        ContentModal
    },
    props: {
        isLoadingMessage: {
            type: String,
            required: true
        },
        // give the modal a name so we can control it outside of the component
        // via the root Vue Instance / Event bus
        name: {
            type: [ String, Boolean ],
            default: "newsletterSubscriptionModal"
        },
        title: {
            type: String,
            required: true
        },
    },
    setup ( props, ctx ) {
        const email = ref( "" )
        const isSubmitting = ref( false )
        const message = ref( "" )
        const errors = ref([])
        const isInvalid = ref( false )
        let callback = () => ({})


        // generate a unique key for this media modal
        // for explicit control within methods
        const key = computed( () => `${ props.name }_${ generateShortUUID() }` )

        onMounted( () => {
            ctx.root.$on( "request:modal", handleShow )
        })

        async function handleShow ({ formData: data, url, callback: callbackFn }) {
            isSubmitting.value = true
            email.value = data.email
            callback = callbackFn
            const { message: responseMessage, error, contentType } = await api.update({
                data,
                route: url,
            })

            if ( error ) {
                isInvalid.value = true

                if ( contentType === "application/json" ) {
                    message.value = responseMessage

                    // if BE returns some specific errors related
                    // to email (or other) fields,
                    // `error` is an Object with this structure:
                    // {[form field]: [error message]}
                    // if there is some general error,
                    // `error` would have this structure
                    // {"result": "error", "message": [error message]}
                    if ( !error.message ) {
                        errors.value = Object.values( error ).map( ( errorMessages ) => errorMessages.join( " " ) )
                    }
                }
                else {
                    message.value = "Apologies, an error occurred. Please chat with us if this continues"
                }
            }
            else {
                isInvalid.value = false
                message.value = responseMessage
            }

            isSubmitting.value = false
        }

        function closeModal () {
            ctx.emit(
                "close",
                {
                    name: props.name
                }
            )
        }


        function handleClose () {
            ctx.emit( "input", !isInvalid.value )
            callback && callback( !isInvalid.value )
            closeModal()
        }


        return {
            email,
            errors,
            handleClose,
            isInvalid,
            isSubmitting,
            key,
            message,
        }
    }
}
</script>

<template>
<content-modal
    class="butter-modal butter-modal--newsLetterSubscription"
    :can-user-close="!isSubmitting"
    :name="name"
    :ref="key"
    @close-modal="handleClose"
>
    <h1 class="NewsLetterSubscriptionModal-head">
        {{ title }}
    </h1>
    <div class="NewsLetterSubscriptionModal-content">
        <div v-if="isSubmitting">
            {{ isLoadingMessage }}
        </div>
        <div v-else-if="isInvalid">
            <p>{{ message }}</p>
            <ul>
                <li
                    v-for="(error, index) in errors"
                    :key="index"
                >
                    {{ error }}
                </li>
            </ul>
        </div>
        <div v-else>
            {{ message }}
        </div>
    </div>
</content-modal>
</template>
